export var ReducerActionKind;
(function (ReducerActionKind) {
    ReducerActionKind["SET"] = "SET";
    ReducerActionKind["SET_EMBED_ITEM"] = "SET_EMBED_ITEM";
})(ReducerActionKind || (ReducerActionKind = {}));
export var ComposerModuleName;
(function (ComposerModuleName) {
    ComposerModuleName["BulletList"] = "bulletList";
    ComposerModuleName["NumberedList"] = "numberedList";
    ComposerModuleName["LargeHeader"] = "largeHeader";
    ComposerModuleName["MediumHeader"] = "mediumHeader";
    ComposerModuleName["Image"] = "image";
    ComposerModuleName["Attachment"] = "attachment";
    ComposerModuleName["Emoji"] = "emoji";
    ComposerModuleName["Mention"] = "mention";
    ComposerModuleName["Embed"] = "embed";
    ComposerModuleName["Code"] = "code";
})(ComposerModuleName || (ComposerModuleName = {}));
//# sourceMappingURL=index.js.map